import { ReactNode, ReactNodeArray } from 'react';
import {
  ModalBackdrop,
  ModalContent,
  ModalHeader,
  ModalCloseButton
} from './Modal.styles';

export const defaultProps = {
  disableBackdropClick: false,
  whiteBg: false,
  className: '',
  showHeader: true,
  headerText: '',
  fullscreenOnMobile: false,
  Header: ModalHeader,
  Content: ModalContent,
  Backdrop: ModalBackdrop,
  CloseButton: ModalCloseButton
};

export type ModalProps = typeof defaultProps & {
  children: ReactNode | ReactNodeArray;
  open: boolean;
  toggleModal: (event: React.MouseEvent<HTMLDivElement>) => void;
  modalTestName: string;
};
